import { queryOptions, useQuery } from '@tanstack/react-query';

import { apiClient } from '@cast/infrastructure-api';

const SECURITY_CONTAINER_IMAGES_FILTERS_QUERY_KEY =
  'security-container-images-filters';

const getContainerImageFiltersQueryKey = (clusterIds?: string[]) =>
  [SECURITY_CONTAINER_IMAGES_FILTERS_QUERY_KEY, clusterIds] as const;

const getContainerImageFiltersQueryOptions = (clusterIds?: string[]) =>
  queryOptions({
    queryKey: getContainerImageFiltersQueryKey(clusterIds),
    queryFn: async () => {
      const { data } =
        await apiClient.securityInsights.getContainerImagesFilters({
          clusterIds,
        });
      return data;
    },
  });

export const useContainerImageFiltersQuery = (clusterIds?: string[]) => {
  const {
    isLoading,
    data: filters,
    error,
    refetch,
  } = useQuery(getContainerImageFiltersQueryOptions(clusterIds));

  return { isLoading, filters, error, refetch };
};
